module.exports = __webpack_public_path__ + "static/media/point-up.156e3511.png";